import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";
import { AbstractObservation, IObservation, IOComponent, ITranslation } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "valueObservation" })
export class ValueObservationPipe implements PipeTransform {
  transform(headerCompo: IOComponent, component: IOComponent[]): number | null {
    let value: number;
    for (const compo of component) {
      if (
        compo.parentObservation?.code.coding[0].code === headerCompo.parentObservation?.code.coding[0].code &&
        compo.code.coding[0].code === headerCompo.code.coding[0].code
      ) {
        value = Tools.isDefined(compo.valueQuantity.value) ? Number(compo.valueQuantity.value) : null; // check if defined because Number(null) === 0
        break;
      }
    }
    // not found
    return !Tools.isDefined(value) || isNaN(value) ? null : value; // check if defined because isNaN(null) === false, null IS a number for javascript
  }
}

export class Observation extends AbstractObservation implements IObservation {
  isDefined(value: unknown): boolean {
    return Tools.isDefined(value);
  }
  getTranslation(definition: ITranslation, lang: string, txtBackup: string): string {
    return Tools.getTranslation(definition, lang, txtBackup);
  }
}
